export const ACCOUNT_OPEN_SESSIONS = 'ACCOUNT_OPEN_SESSIONS';

export default { ACCOUNT_OPEN_SESSIONS };
